// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_334s1","input":"_20hZC","autoComplete":"_1Xgjk","autoCompleteHeading":"_1PPZB","autoCompleteItem":"_1N3cK","cover":"_3rs-7","addAlbumCover":"Vy9eP _3rs-7","meta":"WC4Ya","clearButton":"_3xPmm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/playlist/AlbumPicker.css
// module id = 355
// module chunks = 0